"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScreenReaderSDK = exports.screenReaderSDKFactory = void 0;
const __1 = require("../..");
const assert_1 = require("../../assert");
const reporters_1 = require("../../reporters");
const constants_1 = require("./constants");
const screenReaderSDKFactory = ({ setProps, props }) => ({
    screenReader: {
        get prefix() {
            var _a;
            return (_a = props.screenReader) === null || _a === void 0 ? void 0 : _a.prefix;
        },
        set prefix(value) {
            if (value !== null && !assert_1.assert.isString(value)) {
                (0, reporters_1.reportError)((0, constants_1.getInvalidScreenReaderValueError)('prefix'));
                return;
            }
            setProps({ screenReader: Object.assign(Object.assign({}, props.screenReader), { prefix: value }) });
        },
        get suffix() {
            var _a;
            return (_a = props.screenReader) === null || _a === void 0 ? void 0 : _a.suffix;
        },
        set suffix(value) {
            if (value !== null && !assert_1.assert.isString(value)) {
                (0, reporters_1.reportError)((0, constants_1.getInvalidScreenReaderValueError)('suffix'));
                return;
            }
            setProps({ screenReader: Object.assign(Object.assign({}, props.screenReader), { suffix: value }) });
        },
    },
});
exports.screenReaderSDKFactory = screenReaderSDKFactory;
exports.createScreenReaderSDK = (0, __1.withValidation)(exports.screenReaderSDKFactory, {
    type: ['object'],
    properties: {
        prefix: {
            type: ['string'],
            minLength: 1,
            maxLength: 1000,
        },
        suffix: {
            type: ['string'],
            minLength: 1,
            maxLength: 1000,
        },
    },
});
//# sourceMappingURL=screenReaderSDKFactory.js.map